'use client';

import { useEffect } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { isNative } from '@/lib/native/is-native';
import { hasIapPlugin } from '@/lib/native/iap';

/**
 * Release gate for in-app signup. A binary that ships the IAP plugin can sign
 * up + subscribe in-app, so signup is allowed there. A **pre-IAP** binary
 * (still in users' hands during the store rollout) can't run the purchase flow,
 * so in-app signup would dead-end at the paywall — those stay sign-in-only
 * (App Store 3.1.1) and get bounced to /login. Web is unaffected.
 */
export default function SignupNativeGuard() {
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (isNative() && !hasIapPlugin()) {
      const next = searchParams.get('next');
      router.replace(`/login${next ? `?next=${encodeURIComponent(next)}` : ''}`);
    }
  }, [router, searchParams]);

  return null;
}
